import { hot } from 'react-hot-loader/root';
import Component from './app-redux';

export default hot(Component);
